






























import { Vue, Component, Prop } from 'vue-property-decorator';
import GStudentRecordCompetencyScoreTransition from '@/views/GStudentRecord/GStudentRecordCompetencyScoreTransition.vue';
import GCompetencyLabel from '@/components/GCompetencyLabel.vue';
import GOptionalData from '@/components/GOptionalData.vue';
import { StudentCompetencyGrowth } from '@/models/student/student-competency-growth';
import { ScoreUtils } from '@/utils/score.utils';

@Component({
  name: 'GCompetencyAcademicAbility',
  components: { GOptionalData, GCompetencyLabel, GStudentRecordCompetencyScoreTransition },
  computed: {},
  methods: {},
})
export default class GCompetencyComparison extends Vue {
  @Prop({ default: () => {} }) competencyGrowth: StudentCompetencyGrowth;
  mounted() {}

  getScoreProgressStatusString(count: number, isNew: boolean): string {
    return ScoreUtils.toStringScoreProgressStatus(count, isNew);
  }
}
